<div class="dropdown {{ dropdownClass }}" #dropdown>
  <ng-content select="[dropdown-trigger]"></ng-content>
  <div *ngIf="visible" class="dropdown-popover-container" #dropdownPopoverContainer>
    <div class="dropdown-popover {{ popoverClass }}" #dropdownPopover>
      <ng-content select="[dropdown-item]"></ng-content>
      <ng-content></ng-content>
    </div>
  </div>
</div>
